import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  className?: string;
  onClick?: () => void;
};
export function CtaButton({
  children,
  href = '#precio',
  size = 'lg',
  className = '',
  onClick
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-4 text-base sm:text-lg' : 'px-5 py-3 text-sm sm:text-base';
  return <a href={href} onClick={onClick} className={`group inline-flex items-center justify-center gap-2 rounded-xl bg-brand font-display font-bold text-ink-950 shadow-[0_8px_30px_-8px_rgba(34,197,94,0.6)] transition-all duration-200 hover:bg-brand-hover hover:shadow-[0_10px_36px_-6px_rgba(34,197,94,0.7)] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950 active:scale-[0.98] ${sizing} ${className}`} data-id="element-60" data-mp="qkk7wws69h16">
      <span aria-hidden="true" className="transition-transform duration-200 group-hover:translate-x-0.5" data-id="element-61" data-mp="198ywzeixikzc">
        →
      </span>
      <span data-id="element-62" data-mp="35xfmn2gp0x86">{children}</span>
    </a>;
}